<template>
  <div>
    <div class="px-3 text-start">
      <div class="d-flex align-items-center mb-3">
        <button class="btn btn-outline-primary" @click.prevent="backtolist">
          &lt; Return to list
        </button>
        <h3 class="mb-0 ms-4">
          <span v-if="id > 0">{{ course.name || ('Course ' + id) }}</span>
          <span v-else>Add course</span>
        </h3>
      </div>
      <div class="row">
        <div class="col-12">

          <div v-if="loading" class="text-muted py-4">Loading…</div>
          <div v-else-if="errorMsg" class="alert alert-danger">{{ errorMsg }}</div>

          <div v-else>
            <ul class="nav nav-tabs mb-3">
              <li class="nav-item" v-for="t in tabs" :key="t.id">
                <a class="nav-link" :class="{ active: activeTab === t.id }" href="#" @click.prevent="activeTab = t.id">
                  {{ t.label }}
                </a>
              </li>
            </ul>

            <!-- Course -->
            <div v-if="activeTab === 'course'">
              <div class="row">
                <div class="col-12 col-md-6">
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" style="width: 33%; flex-shrink: 0">Name</label>
                    <div style="width: 67%"><input class="form-control" v-model="course.name" /></div>
                  </div>
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" style="width: 33%; flex-shrink: 0">Slug</label>
                    <div style="width: 67%"><input class="form-control" v-model="course.slug" :disabled="!isNew" /></div>
                  </div>
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" style="width: 33%; flex-shrink: 0">Course label</label>
                    <div style="width: 67%"><input class="form-control" v-model="course.course_label" placeholder="Gothenburg course" /></div>
                  </div>
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" style="width: 33%; flex-shrink: 0">Track</label>
                    <div style="width: 67%">
                      <select class="form-select" v-model="course.track">
                        <option value="certification">Certification</option>
                        <option value="onboarding">Onboarding</option>
                      </select>
                    </div>
                  </div>
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" style="width: 33%; flex-shrink: 0">Language</label>
                    <div style="width: 67%">
                      <select class="form-select" v-model="course.language_id">
                        <option :value="0">None</option>
                        <option v-for="l in languages" :key="l.id" :value="l.id">{{ l.language_name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" for="lhactive" style="width: 33%; flex-shrink: 0">Active</label>
                    <div style="width: 67%">
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="lhactive" v-model="course.active" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" style="width: 33%; flex-shrink: 0">Enrolment summary</label>
                    <div style="width: 67%"><input class="form-control" v-model="course.enrolment_summary" /></div>
                  </div>
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" style="width: 33%; flex-shrink: 0">Location title</label>
                    <div style="width: 67%"><input class="form-control" v-model="course.location_title" /></div>
                  </div>
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" style="width: 33%; flex-shrink: 0">Location address</label>
                    <div style="width: 67%"><input class="form-control" v-model="course.location_address" /></div>
                  </div>
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" style="width: 33%; flex-shrink: 0">Time label</label>
                    <div style="width: 67%"><input class="form-control" v-model="course.time_label" /></div>
                  </div>
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" style="width: 33%; flex-shrink: 0">Language label</label>
                    <div style="width: 67%"><input class="form-control" v-model="course.language_label" /></div>
                  </div>
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" style="width: 33%; flex-shrink: 0">Food label</label>
                    <div style="width: 67%"><input class="form-control" v-model="course.food_label" /></div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" style="width: 33%; flex-shrink: 0">Food note</label>
                    <div style="width: 67%"><input class="form-control" v-model="course.food_note" /></div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-6">
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" style="width: 33%; flex-shrink: 0">Welcome heading</label>
                    <div style="width: 67%"><input class="form-control" v-model="course.welcome_heading" /></div>
                  </div>
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" style="width: 33%; flex-shrink: 0">Welcome subtitle</label>
                    <div style="width: 67%"><input class="form-control" v-model="course.welcome_subtitle" /></div>
                  </div>
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" style="width: 33%; flex-shrink: 0">Event</label>
                    <div style="width: 67%">
                      <select class="form-select" v-model="course.event_id">
                        <option :value="0">None</option>
                        <option v-for="e in events" :key="e.id" :value="e.id">{{ e.title_en || e.title_sv || e.slug }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <label class="col-form-label d-block mb-2">Welcome body (HTML)</label>
                <VueEditor v-model="course.welcome_body" />
              </div>
              <div class="mb-3">
                <label class="col-form-label d-block mb-2">Getting in (HTML)</label>
                <VueEditor v-model="course.getting_in_text" />
              </div>
              <div class="mb-3">
                <label class="col-form-label d-block mb-2">Attendance (HTML)</label>
                <VueEditor v-model="course.attendance_text" />
              </div>
              <button class="btn btn-primary float-end mb-3" :disabled="saving" @click="save">
                <fa-icon name="check" />Save course
              </button>
              <span class="text-success ms-2" v-if="saved">Saved</span>
            </div>

            <!-- Sessions -->
            <div v-if="activeTab === 'sessions' && id > 0">
              <LHCourseSessions :course-id="id" :rows="payload.sessions || []" @changed="refresh" />
            </div>
            <div v-if="activeTab === 'sessions' && id === 0" class="alert alert-secondary">
              Save the course first, then add sessions.
            </div>

            <!-- Steps -->
            <div v-if="activeTab === 'steps' && id > 0">
              <LHCourseSteps :course-id="id" :rows="payload.steps || []" @changed="refresh" />
            </div>
            <div v-if="activeTab === 'steps' && id === 0" class="alert alert-secondary">
              Save the course first, then add steps.
            </div>

            <!-- Materials -->
            <div v-if="activeTab === 'materials' && id > 0">
              <LHCourseMaterials :course-id="id" :rows="payload.materials || []" @changed="refresh" />
            </div>
            <div v-if="activeTab === 'materials' && id === 0" class="alert alert-secondary">
              Save the course first, then add materials.
            </div>

            <!-- Trainers -->
            <div v-if="activeTab === 'trainers' && id > 0">
              <LHCourseTrainers :course-id="id" :rows="payload.trainers || []" @changed="refresh" />
            </div>
            <div v-if="activeTab === 'trainers' && id === 0" class="alert alert-secondary">
              Save the course first, then add trainers.
            </div>

            <!-- Terms -->
            <div v-if="activeTab === 'terms' && id > 0">
              <LHCourseTerms :course-id="id" :rows="payload.terms || []" @changed="refresh" />
            </div>
            <div v-if="activeTab === 'terms' && id === 0" class="alert alert-secondary">
              Save the course first, then add terms.
            </div>

            <!-- Sue KB -->
            <div v-if="activeTab === 'suekb' && id > 0">
              <LHCourseSueKb :course-id="id" :rows="payload.sue_kb || []" @changed="refresh" />
            </div>
            <div v-if="activeTab === 'suekb' && id === 0" class="alert alert-secondary">
              Save the course first, then add knowledge entries.
            </div>

            <!-- Enrolments -->
            <div v-if="activeTab === 'enrolments' && id > 0">
              <LHCourseEnrolments :course-id="id" :steps="payload.steps || []" @changed="noop" />
            </div>
            <div v-if="activeTab === 'enrolments' && id === 0" class="alert alert-secondary">
              Save the course first, then enrol users.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueEditor from './CustomControls/VueEditor.vue'
import LHCourseSessions from './learninghub/LHCourseSessions.vue'
import LHCourseSteps from './learninghub/LHCourseSteps.vue'
import LHCourseMaterials from './learninghub/LHCourseMaterials.vue'
import LHCourseTrainers from './learninghub/LHCourseTrainers.vue'
import LHCourseTerms from './learninghub/LHCourseTerms.vue'
import LHCourseSueKb from './learninghub/LHCourseSueKb.vue'
import LHCourseEnrolments from './learninghub/LHCourseEnrolments.vue'

export default {
  name: 'LearningHubCourse',
  components: {
    VueEditor,
    LHCourseSessions, LHCourseSteps, LHCourseMaterials,
    LHCourseTrainers, LHCourseTerms, LHCourseSueKb, LHCourseEnrolments
  },
  props: {
    courseId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      id: this.courseId,
      isNew: false,
      activeTab: 'course',
      course: this.emptyCourse(),
      payload: {},
      loading: true,
      saving: false,
      events: [],
      languages: [],
      saved: false,
      errorMsg: ''
    }
  },
  computed: {
    tabs () {
      return [
        { id: 'course', label: 'Course' },
        { id: 'sessions', label: 'Sessions' },
        { id: 'steps', label: 'Steps' },
        { id: 'materials', label: 'Materials' },
        { id: 'trainers', label: 'Trainers' },
        { id: 'terms', label: 'Terms' },
        { id: 'suekb', label: 'Sue KB' },
        { id: 'enrolments', label: 'Enrolments' }
      ]
    }
  },
  mounted () {
    this.events_get()
    this.languages_get()
    if (this.id > 0) {
      this.refresh()
    } else {
      this.isNew = true
      this.loading = false
    }
  },
  methods: {
    backtolist () {
      this.$emit('back')
    },
    async events_get () {
      try {
        const res = await this.$store.dispatch('events_admin_list', { limit: 500 })
        this.events = res.data.result
      } catch (e) { this.events = [] }
    },
    async languages_get () {
      try {
        const res = await this.$store.dispatch('languages_fetch')
        this.languages = res.data.result
      } catch (e) { this.languages = [{ id: 38, language_code: 'en', language_name: 'English' }] }
    },
    emptyCourse () {
      return {
        name: '', slug: '', course_label: '', track: 'certification',
        language_id: 0, event_id: 0, active: true, enrolment_summary: '',
        welcome_heading: '', welcome_subtitle: '', welcome_body: '',
        location_title: '', location_address: '',
        time_label: '', language_label: '', food_label: '', food_note: '',
        getting_in_text: '', attendance_text: ''
      }
    },
    noop () {},
    async refresh () {
      if (this.id <= 0) return
      this.loading = true
      this.errorMsg = ''
      try {
        const res = await this.$store.dispatch('learninghub_course_fetch', { id: this.id })
        this.course = { ...this.emptyCourse(), ...res.data.result.course }
        this.payload = res.data.result
      } catch (e) {
        this.errorMsg = e.response && e.response.data && typeof e.response.data.result === 'string'
          ? e.response.data.result : (e.message || 'Load failed')
      }
      this.loading = false
    },
    buildBody () {
      return {
        name: this.course.name,
        slug: this.course.slug,
        course_label: this.course.course_label,
        track: this.course.track,
        language_id: this.course.language_id,
        event_id: this.course.event_id,
        active: this.course.active ? 1 : 0,
        enrolment_summary: this.course.enrolment_summary,
        welcome_heading: this.course.welcome_heading,
        welcome_subtitle: this.course.welcome_subtitle,
        welcome_body: this.course.welcome_body,
        location_title: this.course.location_title,
        location_address: this.course.location_address,
        time_label: this.course.time_label,
        language_label: this.course.language_label,
        food_label: this.course.food_label,
        food_note: this.course.food_note,
        getting_in_text: this.course.getting_in_text,
        attendance_text: this.course.attendance_text
      }
    },
    async save () {
      this.saving = true
      this.errorMsg = ''
      this.saved = false
      try {
        const body = this.buildBody()
        if (this.isNew) {
          const res = await this.$store.dispatch('learninghub_course_save', { body })
          this.id = res.data.result.id
          this.isNew = false
          this.$emit('saved', this.id)
        } else {
          await this.$store.dispatch('learninghub_course_update', { id: this.id, body })
        }
        this.saved = true
        setTimeout(() => { this.saved = false }, 2000)
        this.refresh()
      } catch (e) {
        this.errorMsg = e.response && e.response.data && typeof e.response.data.result === 'string'
          ? e.response.data.result : (e.message || 'Save failed')
      }
      this.saving = false
    }
  }
}
</script>

<style>
.lh-editor {
  font-size: 0.9rem;
}
.lh-editor .ql-container {
  min-height: 120px;
}
</style>
